var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Box, Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { SigefApi } from '../apis/Sigef-api';
import { HandleError } from '../modules/utils/HandleError';
import { ShowContent } from './ShowContent';
export var SessaoSIGEF = function (_a) {
    var setSigefIsOnline = _a.setSigefIsOnline, sigefIsOnline = _a.sigefIsOnline, _b = _a.usarSigef, usarSigef = _b === void 0 ? true : _b;
    var _c = useState(), error = _c[0], setError = _c[1];
    useEffect(function () {
        verifySessaoSigef();
    }, []);
    useEffect(function () {
        var timer = setInterval(function () {
            verifySessaoSigef();
        }, usarSigef ? 60000 : 600000);
        return function () { return clearInterval(timer); };
    }, [usarSigef]);
    useEffect(function () {
    }, [sigefIsOnline, usarSigef]);
    var verifySessaoSigef = function () {
        SigefApi.verifySessaoSigef()
            .then(function (response) {
            setSigefIsOnline(response);
        })
            .catch(function (err) {
            setError(err);
        });
    };
    var show = useMemo(function () {
        return !sigefIsOnline && usarSigef;
    }, [sigefIsOnline, usarSigef]);
    return (_jsxs(ShowContent, __assign({ show: show }, { children: [_jsx(Grid, __assign({ container: true, textAlign: 'center' }, { children: _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsxs(Alert, __assign({ severity: "warning", sx: {
                            color: '#b76017',
                            '& .MuiSvgIcon-root': {
                                transform: 'scale(1.5)',
                                margin: '9px'
                            },
                            '& .MuiAlert-message': {
                                width: '100%',
                                textAlign: 'center',
                            },
                        } }, { children: [_jsx(Box, __assign({ component: "p", sx: { m: 0 } }, { children: "A API SIGEF est\u00E1 fora do ar. Preencha manualmente todos os campos obrigat\u00F3rios para seguir com o cadastro." })), _jsx(Box, __assign({ component: "p", sx: { m: 0 } }, { children: "Os dados informados ser\u00E3o posteriormente verificados pela equipe t\u00E9cnica" }))] })) })) })), _jsx(HandleError, { error: error, handleClose: function () { return setError(undefined); } })] })));
};
